import { render, staticRenderFns } from "./chargeStatistics.vue?vue&type=template&id=a2803328&scoped=true&"
import script from "./chargeStatistics.vue?vue&type=script&lang=js&"
export * from "./chargeStatistics.vue?vue&type=script&lang=js&"
import style0 from "./chargeStatistics.vue?vue&type=style&index=0&id=a2803328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2803328",
  null
  
)

export default component.exports